import { FC, Fragment, useState } from 'react'

import CopyToClipboard from 'react-copy-to-clipboard'

import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';

import { useFetch } from '@np/np_webcomponentlib'

import {ResultOperation} from '@np/np_webcomponentlib'
import React from 'react';

export interface DataForColumn {
    data: string
    classContainer: string
}



//Данные для организации событий по кнопке
export interface DataForEvent {
    idUnique: string
    event: (idUnique: string) => void
    title: string
}

export interface DataForClipboard {
    data: string
    title: string
}

export const ColumnData: FC<DataForColumn> = ({ data, classContainer }: DataForColumn) => {
    return <div style={{ textAlign: 'center' }} className={classContainer}>{data}</div>
}

export const ColumnEvent: FC<DataForEvent> = ({ idUnique, event, title }: DataForEvent) => {
    return <i onClick={() => { event(idUnique) }} className={title}></i>
}

export const ColumnWithCopyToClipboard: FC<DataForClipboard> = ({ data, title }: DataForClipboard) => {
    return (<CopyToClipboard text={data}>
        <span>
            <i className={"fe fe-clipboard eventIcom"}></i>
        </span>
      </CopyToClipboard>)
    
}




export const DeleteEntity: FC<{ idUnique: string, apiPath: string, onResult: (status: ResultOperation) => void }> = ({ idUnique, apiPath, onResult }) => {

    const [{  }, doFetchDeleteComPlace] = useFetch(
        `${apiPath}/${idUnique}`
    )//error, isLoading, response

    const remove = () => {
        doFetchDeleteComPlace({
            method: 'DELETE',
            "Content-Type": "application/json"
        }).then(responce => {
            console.log('Delete:', responce)
            onResult(responce.result)
        })
    }

    const [show2, setShow2] = useState(false);
    const xtralargemodalClose = () => setShow2(false);
    const xtralargemodalShow = () => setShow2(true);


    return (
        <Fragment>
            <Modal size="sm" show={show2} onHide={xtralargemodalClose}>
                <ModalHeader>
                    <ModalTitle as="h5">Удаление</ModalTitle>
                    <span className="d-flex ms-auto" onClick={xtralargemodalClose}><i className='fe fe-x ms-auto' ></i></span>
                </ModalHeader>
                <ModalBody>
                    Вы уверены что хотите удалить сущность?
                </ModalBody>
                <ModalFooter>
                    <Button variant="danger" onClick={() => { remove(); xtralargemodalClose() }}>
                        Да
                    </Button>
                    <Button variant="primary" onClick={xtralargemodalClose}>
                        Нет
                    </Button>
                </ModalFooter>
            </Modal>


            <i className="fe fe-trash-2 btn-danger" onClick={() => xtralargemodalShow()}></i>
        </Fragment>)
}


export const DeleteEntityNew: FC<{ idUnique: string, apiPath: string, onResult: (status: ResultOperation) => void }> = ({ idUnique, apiPath, onResult }) => {

    const [{  }, doFetchDeleteComPlace] = useFetch(
        `${apiPath}`
    )//error, isLoading, response

    const remove = () => {
        doFetchDeleteComPlace({
            method: 'DELETE',
            "Content-Type": "application/json",
            data: {
                idEntity: idUnique
            }
        }).then(responce => {
            console.log('Delete:', responce)
            onResult(responce.result)
        })
    }

    const [show2, setShow2] = useState(false);
    const xtralargemodalClose = () => setShow2(false);
    const xtralargemodalShow = () => setShow2(true);


    return (
        <Fragment>
            <Modal size="sm" show={show2} onHide={xtralargemodalClose}>
                <ModalHeader>
                    <ModalTitle as="h5">Удаление</ModalTitle>
                    <span className="d-flex ms-auto" onClick={xtralargemodalClose}><i className='fe fe-x ms-auto' ></i></span>
                </ModalHeader>
                <ModalBody>
                    Вы уверены что хотите удалить сущность?
                </ModalBody>
                <ModalFooter>
                    <Button variant="danger" onClick={() => { remove(); xtralargemodalClose() }}>
                        Да
                    </Button>
                    <Button variant="primary" onClick={xtralargemodalClose}>
                        Нет
                    </Button>
                </ModalFooter>
            </Modal>


            <i className="fe fe-trash-2 btn-danger" onClick={() => xtralargemodalShow()}></i>
        </Fragment>)

}